export default __webpack_public_path__ + "static/media/Legguards of the Black Pharaoh.803f06b7.jpg";